





















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from "@/definitions";

import { CalendarLayer } from "@/model/document2/page/surface/design/layer/calendarLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from "@/commonComponents/adjustedBalloon/adjustedBalloon.vue"

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";

import { DebugHelper } from "@/helper/debugHelper"
import { ResourceHelper } from "@/helper/resourceHelper"


@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
  }
})

export default class CalendarCommonStyle extends Vue
{
    @Prop() private layer!: CalendarLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private onChangingColor(color, tag)
    {
        this.changeLayerProperty(color, tag, false);
    }

    private onChangedColor(color, tag)
    {
        this.changeLayerProperty(color, tag, true);
    }

    // 開閉のアニメーション
    // TODO Props
    openStatus = {
        opend: true
    };

    calendarCommonTransformContentsOpenAnimate = false;
    calendarCommonTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.calendarCommonTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.calendarCommonTransformContentsCloseAnimate = false;
            this.calendarCommonTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.calendarCommonTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.calendarCommonTransformContentsOpenAnimate = false;
        }, 250);
        }
    }

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get calendarCommonTransformOpendStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0 && this.openStatus.opend){
            style = {
                height: "calc(232% / 752 * 100) !important"
            };
        }
        return style;
    }

    private get commonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "20.8%"
            };
        }
        return style;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
